import { Banner, Text } from "@jsq/ds/core";
import { formatDate } from "~/pages/FundAccounting/utils/helpers";
import { generateGpMainUrl } from "~/utils/url";

type Props = {
  arenaName: string;
  arenaSubdomain: string;
  entityId: number;
  firstTransferDate: string;
  entityTransferEnabled: boolean;
  positionId: number;
};

const NO_ENTITY_SETTINGS_DESCRIPTION =
  "Go to the entity and turn off transfer accounting under metrics settings to sync transfers.";
const UnsyncedBanner = (props: Props) => {
  const showEntitySettingsError = props.entityTransferEnabled;
  const bannerDescription = (
    <Text style={{ maxWidth: "700px" }}>
      {showEntitySettingsError
        ? NO_ENTITY_SETTINGS_DESCRIPTION
        : `The earliest transfer event on ${formatDate(props.firstTransferDate)} was not recorded in ${props.arenaName}’s
      workspace. Record the relevant transfer event to sync.`}
    </Text>
  );
  const gpMainUrl = generateGpMainUrl(props.arenaSubdomain);
  return (
    <Banner
      variant="danger"
      title="Unable to sync transfers"
      description={bannerDescription}
      style={{ marginBottom: "24px" }}
      buttonProps={{
        children: "Go to entity",
        variant: "neutral",

        onClick: () => {
          let gpUrl = "";
          if (showEntitySettingsError) {
            gpUrl = `${gpMainUrl}/account/${props.entityId}`;
          } else {
            gpUrl = `${gpMainUrl}/position/${props.positionId}/ownership`;
          }

          window.open(gpUrl, "_blank");
        },
        icon: "external-link",
        iconPosition: "right",
      }}
    />
  );
};

export default UnsyncedBanner;
